/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Interview_Prepare_Questions_CountInputs */

const en_interview_prepare_questions_count = /** @type {(inputs: Interview_Prepare_Questions_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Questions (${i?.count})`)
};

const de_interview_prepare_questions_count = /** @type {(inputs: Interview_Prepare_Questions_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Fragen (${i?.count})`)
};

const fr_interview_prepare_questions_count = /** @type {(inputs: Interview_Prepare_Questions_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Questions (${i?.count})`)
};

const es_interview_prepare_questions_count = /** @type {(inputs: Interview_Prepare_Questions_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Preguntas (${i?.count})`)
};

const it_interview_prepare_questions_count = /** @type {(inputs: Interview_Prepare_Questions_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Domande (${i?.count})`)
};

const nl_interview_prepare_questions_count = /** @type {(inputs: Interview_Prepare_Questions_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Vragen (${i?.count})`)
};

const pl_interview_prepare_questions_count = /** @type {(inputs: Interview_Prepare_Questions_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Pytania (${i?.count})`)
};

const fi_interview_prepare_questions_count = /** @type {(inputs: Interview_Prepare_Questions_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Kysymyksiä (${i?.count})`)
};

const da_interview_prepare_questions_count = /** @type {(inputs: Interview_Prepare_Questions_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Spørgsmål (${i?.count})`)
};

const sv_interview_prepare_questions_count = /** @type {(inputs: Interview_Prepare_Questions_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Frågor (${i?.count})`)
};

/**
* | output |
* | --- |
* | "Questions ({count})" |
*
* @param {Interview_Prepare_Questions_CountInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const interview_prepare_questions_count = /** @type {((inputs: Interview_Prepare_Questions_CountInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Interview_Prepare_Questions_CountInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_interview_prepare_questions_count(inputs)
	if (locale === "fr") return fr_interview_prepare_questions_count(inputs)
	if (locale === "es") return es_interview_prepare_questions_count(inputs)
	if (locale === "it") return it_interview_prepare_questions_count(inputs)
	if (locale === "nl") return nl_interview_prepare_questions_count(inputs)
	if (locale === "pl") return pl_interview_prepare_questions_count(inputs)
	if (locale === "fi") return fi_interview_prepare_questions_count(inputs)
	if (locale === "da") return da_interview_prepare_questions_count(inputs)
	if (locale === "sv") return sv_interview_prepare_questions_count(inputs)
	return en_interview_prepare_questions_count(inputs)
});